// extracted by mini-css-extract-plugin
export default {"container":"container_fuXmm","card":"card_S3WBT","section-title":"section-title_pR0WQ"};